import { render } from "./SwitchCupHomeGuestRequestPage1.vue?vue&type=template&id=3a42a3e4"
import script from "./SwitchCupHomeGuestRequestPage1.vue?vue&type=script&lang=js"
export * from "./SwitchCupHomeGuestRequestPage1.vue?vue&type=script&lang=js"

import exportComponent from "/home/Daten/Entwicklung/repositories/bdl_ui/de.stone.bdl.management.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__